import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";
import { useCallStore } from "~/stores/useCallStore";

const outgoingSearchSchema = z.object({
  user_id: z.string(),
  user_name: z.string().catch(""),
  user_avatar: z.string().optional(),
  user_age: z.coerce.number().optional(),
});

export const Route = createFileRoute("/_authenticated/video")({
  validateSearch: outgoingSearchSchema,
  beforeLoad: ({ search }) => {
    const { phase } = useCallStore.getState();

    if (phase.type !== "idle") {
      throw redirect({ to: "/" });
    }

    throw redirect({
      to: "/call/video/outgoing",
      search: {
        partner_id: search.user_id,
        partner_name: search.user_name,
        partner_avatar: search.user_avatar,
        partner_age: search.user_age,
      },
    });
  },
});
